import React from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { closeView } from '.';

function ViewResidencesView ( { residences, closeView } ) {

  return (
      <CSSTransition className='residences--apartment' in={ residences.isViewActive } timeout={ 300 } classNames='fade' unmountOnExit>
          <div>
              
              <img className='shared--img-fill-views' src={ process.env.PUBLIC_URL+'/img/views/'+residences.view +'.jpg'} /*width='1920' height='1080'*/ alt='residences level' />
              <button className='residences--apartment__close-btn' onClick={ closeView } />
          </div>
      </CSSTransition> 
  );

}


const mapStateToProps = (state) => ({
  residences: state.residences
})

const mapDispatchToProps = (dispatch) => ({
  closeView: () => dispatch(closeView())
})


export default connect(mapStateToProps, mapDispatchToProps)(ViewResidencesView)